export type TemperatureAlertRule = {
  id: string;
  enable: boolean;
  topic: string;
  title: string;
  min: number | null;
  max: number | null;
  hysteresis: number;
  alarmDelayMin: number;
  resetDelayMin: number;
  criticality: 1 | 2 | 3;
  channels?: Array<'pushover' | 'mail'>;
  source?: 'manual' | 'flow';
  flowId?: string;
  /** Payload text that raises the alarm. Empty keeps the numeric min/max rule. */
  match?: string;
  /** Optional path into the MQTT payload. Empty reads the message text. */
  field?: string;
  /** When a match rule notifies. */
  edge?: 'both' | 'enter' | 'leave';
};

export type AlertEvent = {
  id: string;
  at: number;
  ruleId: string;
  title: string;
  topic: string;
  side: 'ok' | 'low' | 'high' | 'on' | 'off';
  temp: number | null;
  text?: string;
  message: string;
  criticality?: 1 | 2 | 3;
  /** `ack` is an operator acknowledgement. Missing means a process event. */
  kind?: 'event' | 'ack';
};

export type PushoverChannelPublic = {
  enable: boolean;
  user: string;
  tokenSet: boolean;
};

export type MailChannelPublic = {
  enable: boolean;
  host: string;
  port: number;
  secure: boolean;
  user: string;
  from: string;
  to: string;
  passwordSet: boolean;
};

export type AlertChannelsPublic = {
  pushover: PushoverChannelPublic;
  mail: MailChannelPublic;
};

export type AlertChannelsDraft = {
  pushover: {
    enable: boolean;
    user: string;
    token: string;
  };
  mail: {
    enable: boolean;
    host: string;
    port: number;
    secure: boolean;
    user: string;
    password: string;
    from: string;
    to: string;
  };
};

export function emptyChannelsPublic(): AlertChannelsPublic {
  return {
    pushover: { enable: false, user: '', tokenSet: false },
    mail: {
      enable: false,
      host: '',
      port: 587,
      secure: false,
      user: '',
      from: '',
      to: '',
      passwordSet: false,
    },
  };
}

export function emptyChannelsDraft(): AlertChannelsDraft {
  return {
    pushover: { enable: false, user: '', token: '' },
    mail: {
      enable: false,
      host: '',
      port: 587,
      secure: false,
      user: '',
      password: '',
      from: '',
      to: '',
    },
  };
}

export function draftFromPublic(channels: AlertChannelsPublic | undefined): AlertChannelsDraft {
  const empty = emptyChannelsDraft();
  if (!channels) {
    return empty;
  }
  return {
    pushover: {
      enable: channels.pushover?.enable === true,
      user: channels.pushover?.user || '',
      token: '',
    },
    mail: {
      enable: channels.mail?.enable === true,
      host: channels.mail?.host || '',
      port: Number(channels.mail?.port) > 0 ? Number(channels.mail.port) : 587,
      secure: channels.mail?.secure === true,
      user: channels.mail?.user || '',
      password: '',
      from: channels.mail?.from || '',
      to: channels.mail?.to || '',
    },
  };
}
